import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestCaseVersionConfirmationModal = ({
  dropdownElInfo,
  deleteVersionOpen,
  setDeleteVersionOpen,
  setTestCasesToggler
}) => {
  const [loading, setLoading] = useState(false)

  const handleCloseDeleteDialog = () => {
    setDeleteVersionOpen(false)
  }

  const handleDeleteVersion = async () => {
    setLoading(true)
    try {
      await PageService.deleteProjectVersion(dropdownElInfo.id)
      setTestCasesToggler(prev => !prev)
      setDeleteVersionOpen(false)
      setLoading(false)
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteVersionOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestCasesModal">
        <DialogTitle className="deleteTestCasesModalTitle">
          Confirm Delete Version
        </DialogTitle>
        <DialogContent className="deleteTestCasesModalContent">
          <DialogContentText className="deleteTestCasesModalContentText">
            Are you sure you want to delete this version? Any related test cases and history will be lost. This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestCasesModalActions">
          <Button className="deleteTestCasesModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestCasesModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestCasesModalButton" onClick={handleDeleteVersion} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestCaseVersionConfirmationModal
